import React, { useState } from 'react';
import { User, LogOut, Settings, ChevronDown, UserCheck, Shield } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import MasterCoifaLogo from './MasterCoifaLogo';

export default function Topbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const { currentUser, activeOperator, logout } = useApp();

  const toggleDropdown = () => {
    setIsDropdownOpen(prev => !prev);
  };

  return (
    <header className="fixed-top bg-dark text-white border-bottom border-secondary d-flex align-items-center justify-content-between px-2 px-sm-4" style={{ height: '70px', zIndex: 1030, backgroundColor: '#1a1d20' }}>
      {/* Brand / Logo */}
      <div className="d-flex align-items-center gap-1 gap-sm-3">
        <div className="d-none d-sm-block">
          <MasterCoifaLogo width="190px" height="42px" light={true} />
        </div>
        <div className="d-block d-sm-none">
          <MasterCoifaLogo width="125px" height="28px" light={true} />
        </div>
        <span className="text-secondary opacity-50 d-none d-sm-inline" style={{ fontSize: '1.5rem', fontWeight: 300 }}>|</span>
        <span className="text-light-emphasis text-xs text-uppercase tracking-wider font-mono fw-bold d-none d-sm-inline" style={{ color: '#ffffff', letterSpacing: '0.8px' }}>
          Controle de Produção
        </span>
      </div>

      {/* Right Side Controls */}
      <div className="d-flex align-items-center gap-1 gap-sm-3">
        
        {/* User Dropdown */}
        <div className="position-relative">
          <button 
            id="user-menu-button"
            onClick={toggleDropdown}
            className="btn btn-outline-secondary text-white border-0 d-flex align-items-center gap-2 py-1.5 px-2.5 hover:bg-secondary rounded cursor-pointer"
            type="button"
            aria-expanded={isDropdownOpen}
            style={{ backgroundColor: 'transparent' }}
          >
            <div className="bg-primary-subtle rounded-circle p-1 d-flex align-items-center justify-content-center text-primary" style={{ width: '34px', height: '34px', backgroundColor: '#eaeaea' }}>
              <User size={18} className="text-dark" strokeWidth={2.5} />
            </div>
            
            <div className="text-start d-none d-md-block" style={{ lineHeight: '1.2' }}>
              <div className="text-xxs text-muted text-uppercase font-mono fw-bold" style={{ color: '#a0a2a5' }}>
                {activeOperator?.role}
              </div>
              <div className="text-sm font-sans fw-semibold text-white">
                {activeOperator?.name}
              </div>
            </div>
            <ChevronDown size={14} className={`text-muted transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`} />
          </button>

          {/* Stateful Dropdown Menu */}
          {isDropdownOpen && (
            <>
              {/* Backdrop click-close overlay */}
              <div className="position-fixed w-100 h-100 top-0 start-0" style={{ zIndex: 999, cursor: 'default' }} onClick={() => setIsDropdownOpen(false)} />
              
              <ul className="dropdown-menu dropdown-menu-end show position-absolute end-0 shadow-lg mt-2 bg-dark border border-secondary text-light rounded py-2 d-block" style={{ zIndex: 1000, minWidth: '240px', backgroundColor: '#212529' }}>
                <li className="px-3 py-2 border-bottom border-secondary mb-1">
                  <span className="badge bg-warning text-dark text-xxs mb-1 font-mono fw-bold">{activeOperator?.role}</span>
                  <p className="fw-bold text-white mb-0 text-sm font-sans">{activeOperator?.name}</p>
                  <p className="text-muted text-xs mb-0 font-mono" style={{ fontSize: '0.75rem' }}>{activeOperator?.email}</p>
                </li>
                <li>
                  <a className="dropdown-item text-light d-flex align-items-center gap-2 py-2 cursor-pointer hover:bg-secondary" href="#/settings" onClick={() => setIsDropdownOpen(false)}>
                    <Settings size={16} className="text-warning" />
                    <span className="font-sans text-sm">Configurações</span>
                  </a>
                </li>
                <li><hr className="dropdown-divider border-secondary" /></li>
                <li>
                  <button className="dropdown-item text-danger d-flex align-items-center gap-2 py-2 cursor-pointer hover:bg-danger-subtle w-100 text-start border-0 bg-transparent" onClick={() => { setIsDropdownOpen(false); logout(); }}>
                    <LogOut size={16} />
                    <span className="font-sans text-sm fw-bold">Sair / Logout</span>
                  </button>
                </li>
              </ul>
            </>
          )}
        </div>

      </div>
    </header>
  );
}
